import React from 'react'
import { Card, Typography, Flex } from 'antd'
import type { FlowStep } from '@/data'
import { FormStepEditor } from '../shared/FormStepEditor'

const { Text } = Typography

interface GettingStartedBuilderProps {
  steps: FlowStep[]
  onChange: (steps: FlowStep[]) => void
  onDeleteStep?: (stepId: number) => void
}

export const GettingStartedBuilder: React.FC<GettingStartedBuilderProps> = ({
  steps,
  onChange,
  onDeleteStep,
}) => {
  return (
    <Card title="Getting Started Steps" style={{ maxWidth: 700 }}>
      <Flex vertical gap="middle" style={{ width: '100%' }}>
        <Text type="secondary">
          A simple two-step lead capture funnel. Configure the form fields
          collected across each step.
        </Text>

        <FormStepEditor
          formSteps={steps}
          onChange={onChange}
          onDeleteStep={onDeleteStep}
        />

        <Text type="secondary" style={{ fontSize: 12 }}>
          {steps.length} form step{steps.length !== 1 ? 's' : ''} configured
        </Text>
      </Flex>
    </Card>
  )
}
